import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { SdHtmlComponent, SdSkeletonComponent, SdTitleComponent, SkeletonAppearanceEnum } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-wysiwyg-paragraph',
  templateUrl: './wysiwyg-paragraph.component.html',
  styleUrls: ['./wysiwyg-paragraph.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdSkeletonComponent,
    SdHtmlComponent
  ]
})
export class SdWysiwygParagraphComponent {
  SkeletonAppearanceEnum = SkeletonAppearanceEnum;

  @Input()
  isLoading = false;

  @Input()
  title: string;

  @Input()
  subtitle: string;

  @Input()
  content: string;

  @Input()
  titleLevel: number;
}
